export const enum Usefulness {
  Duplicate = 0,
}
